<div *ngIf="vademecum">
    <p-toast></p-toast>
    <div [formGroup]="personalForm" class="personal-form">
      <table>
          <tr>
              <td class="first-column">
                Last name:
              </td>
              <td class="second-column">
                <input formControlName="studentLastName">
              </td>
            </tr>
            <tr>
              <td>
                First name:
              </td>
              <td>
                  <input formControlName="studentFirstName">
              </td>
            </tr>
        <tr>
          <td class="first-column">
            Student phone:
          </td>
          <td class="second-column">
            <input type="text" formControlName="studentMobile">
          </td>
        </tr>
        <tr>
          <td>
            First Name:
          </td>
          <td>
            <input type="text" formControlName="firstParentFirstName">
          </td>
        </tr>
        <tr>
            <td>
              Last Name:
            </td>
            <td>
              <input type="text" formControlName="firstParentLastName">
            </td>
          </tr>
          <tr>
              <td class="first-column">
                First parent phone:
              </td>
              <td class="second-column">
                <input type="text" formControlName="firstParentMobile">
              </td>
            </tr>
            <tr>
                <td>
                  First Name:
                </td>
                <td>
                  <input type="text" formControlName="secondParentFirstName">
                </td>
              </tr>
              <tr>
                  <td>
                    Last Name:
                  </td>
                  <td>
                    <input type="text" formControlName="secondParentLastName">
                  </td>
                </tr>

      </table>
    </div>
  <div [formGroup]="medicalForm" class="medical-form">
    <table>
     
      <tr>
        <td>
          Street:
        </td>
        <td>
          <input type="text" formControlName="streetName">
        </td>
      </tr>
      <tr>
        <td>
          number:
        </td>
        <td>
          <input type="text" formControlName="streetNumber">
        </td>
      </tr>
      <tr>
        <td>
          City:
        </td>
        <td>
          <input type="text" formControlName="city">
        </td>
      </tr>
      <tr>
        <td>
          Post code:
        </td>
        <td>
          <input type="text" formControlName="postCode">
        </td>
      </tr>
      <tr>
        <td>
          Birth date:
        </td>
        <td>
          <p-calendar showButtonbar="false" formControlName="birthDate" [monthNavigator]="true" [yearNavigator]="true"
            yearRange="1990:2020" dateFormat="dd/mm/yy" [showOtherMonths]="true" [showIcon]="true"></p-calendar>
        </td>
      </tr>
      <tr>
        <td>
          Start date:
        </td>
        <td>
          <p-calendar showButtonbar="false" formControlName="startDate" [monthNavigator]="true" dateFormat="dd/mm/yy"
            [showOtherMonths]="true" [showIcon]="true"></p-calendar>
        </td>
      </tr>
      <tr>
        <td>
          End date:
        </td>
        <td>
          <p-calendar showButtonbar="false" formControlName="endDate" [monthNavigator]="true" dateFormat="dd/mm/yy"
            [showOtherMonths]="true" [showIcon]="true"></p-calendar>
        </td>
      </tr>
      <tr>
        <td>
          Selected Language:
        </td>
        <td>
          <select formControlName="targetLanguage">
            <option *ngFor="let language of targetLanguages" [value]="language">{{language.name | titlecase}}</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>
          Doctor name:
        </td>
        <td>
          <input type="text" formControlName="doctorName">
        </td>
      </tr>
      <tr>
        <td>
          Doctor Phone:
        </td>
        <td>
          <input type="text" formControlName="doctorPhoneNumber">
        </td>
      </tr>
      <tr>
        <td>
          Experienced diseases:
        </td>
        <td>
          <textarea formControlName="experiencedDiseases" id="experienced-diseases"></textarea>
        </td>
      </tr>
      <tr>
        <td>
          Diabetes:
        </td>
        <td>
          <input type="checkbox" [value]="true" checked formControlName="hasDiabetes">
        </td>
      </tr>
      <tr>
        <td>
          Asthma:
        </td>
        <td>
          <input type="checkbox" [value]="true" checked formControlName="hasAsthma">
        </td>
      </tr>
      <tr>
        <td>
          Heart trouble:
        </td>
        <td>
          <input type="checkbox" [value]="true" checked formControlName="hasHeartTrouble">
        </td>
      </tr>
      <tr>
        <td>
          Epilepsy:
        </td>
        <td>
          <input type="checkbox" [value]="true" checked formControlName="hasEpilepsy">
        </td>
      </tr>
      <tr>
        <td>
          Rheumatism:
        </td>
        <td>
          <input type="checkbox" [value]="true" checked formControlName="hasRheumatism">
        </td>
      </tr>
      <tr>
        <td>
          Physical disability:
        </td>
        <td>
          <input type="checkbox" [value]="true" checked formControlName="hasPhysicalDisability">
        </td>
      </tr>
      <tr>
        <td>
          Skin affection:
        </td>
        <td>
          <input type="checkbox" [value]="true" checked formControlName="hasSkinAffection">
        </td>
      </tr>
      <tr>
        <td>
          Sleep disorder:
        </td>
        <td>
          <input type="checkbox" [value]="true" checked formControlName="hasSleepDisorder">
        </td>
      </tr>
      <tr>
        <td>
          Mental disorder:
        </td>
        <td>
          <input type="checkbox" [value]="true" checked formControlName="hasMentalDisorder">
        </td>
      </tr>
      <tr>
        <td>
          Description of mental disorder:
        </td>
        <td>
          <textarea i18n-placeholder formControlName="mentalDisorderDescription" placeholder="Précisez ici" cols="30"
            rows="10"></textarea>
        </td>
      </tr>
      <tr>
        <td>
          Other diseases:
        </td>
        <td>
          <textarea formControlName="otherDiseases" id="other-diseases"></textarea>
        </td>
      </tr>
      <tr>
        <td>
          Last skin test date:
        </td>
        <td>
          <p-calendar formControlName="lastSkinTestDate" [monthNavigator]="true" [yearNavigator]="true"
            yearRange="1990:2020" dateFormat="dd/mm/yy" [showOtherMonths]="false" [showIcon]="true"></p-calendar>
        </td>
      </tr>
      <tr>
        <td>
          Skin test result:
        </td>
        <td>
          Positive
          <input type="radio" [value]="true" formControlName="skinTestPositive">
          Negative
          <input type="radio" [value]="false" formControlName="skinTestPositive">
        </td>
      </tr>
      <tr>
        <td>
          Tetanus vaccination:
        </td>
        <td>
          Yes
          <input type="radio" [value]="true" formControlName="hadTetanusVaccination">
          No
          <input type="radio" [value]="false" formControlName="hadTetanusVaccination">
        </td>
      </tr>
      <tr>
        <td>
          Year of tetanus booster:
        </td>
        <td>
          <select formControlName="tetanusBoosterYear">
            <option *ngFor="let year of years" [value]="year">{{year}}</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>
          Allergies to medicines:
        </td>
        <td>
          <input type="checkbox" [value]="true" checked formControlName="hasAllergiesToMedicines">
        </td>
      </tr>
      <tr>
        <td>
          Allergies medicines:
        </td>
        <td>
          <input type="text" formControlName="allergiesCauseMedicine">
        </td>
      </tr>
      <tr>
        <td>
          Allergies to substances:
        </td>
        <td>
          <input type="checkbox" [value]="true" checked formControlName="hasAllergiesToSubstances">
        </td>
      </tr>
      <tr>
        <td>
          Allergies substances:
        </td>
        <td>
          <input type="text" formControlName="allergiesCauseSubstance">
        </td>
      </tr>
      <tr>
        <td>
          Incontinent:
        </td>
        <td>
          Yes
          <input type="radio" [value]="true" formControlName="isIncontinent">
          No
          <input type="radio" [value]="false" formControlName="isIncontinent">
        </td>
      </tr>
      <tr>
        <td>
          Quickly tired:
        </td>
        <td>
          Yes
          <input type="radio" [value]="true" formControlName="isQuicklyTired">
          No
          <input type="radio" [value]="false" formControlName="isQuicklyTired">
        </td>
      </tr>
      <tr>
        <td>
          Sensitive to chilling:
        </td>
        <td>
          Yes
          <input type="radio" [value]="true" formControlName="isSensitiveToChilling">
          No
          <input type="radio" [value]="false" formControlName="isSensitiveToChilling">
        </td>
      </tr>
      <tr>
        <td>
          Can sport without risk:
        </td>
        <td>
          Yes
          <input type="radio" [value]="true" formControlName="canSportWithoutRisk">
          No
          <input type="radio" [value]="false" formControlName="canSportWithoutRisk">
        </td>
      </tr>
      <tr>
        <td>
          Description of risk to sport:
        </td>
        <td>
          <textarea i18n-placeholder placeholder="Precisez ici" cols="30" rows="10"
            formControlName="riskDescriptionToSport"></textarea>
        </td>
      </tr>
      <tr>
        <td>
          Need medical treatment:
        </td>
        <td>
          Yes
          <input type="radio" [value]="true" formControlName="needMedicalTreatment">
          No
          <input type="radio" [value]="false" formControlName="needMedicalTreatment">
        </td>
      </tr>
      <tr>
        <td>
          Quantity of medicines:
        </td>
        <td>
          <input formControlName="medicinesQuantity">
        </td>
      </tr>
      <tr>
        <td>
          Blood type:
        </td>
        <td>
          <select formControlName="bloodType" id="blood-type" [compareWith]="compareBloodTypeId">
            <option value="null" disabled>Selectionner le groupe</option>
            <option [ngValue]="bloodTypes[0]">A+</option>
            <option [ngValue]="bloodTypes[1]">A-</option>
            <option [ngValue]="bloodTypes[2]">B+</option>
            <option [ngValue]="bloodTypes[3]">B-</option>
            <option [ngValue]="bloodTypes[4]">O+</option>
            <option [ngValue]="bloodTypes[5]">O-</option>
            <option [ngValue]="bloodTypes[6]">AB+</option>
            <option [ngValue]="bloodTypes[7]">AB-</option>
            <option [ngValue]="bloodTypes[8]">I don't know</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>
          Other informations:
        </td>
        <td>
          <textarea formControlName="otherInformations" cols="30" rows="5" id="other-infos"></textarea>
        </td>
      </tr>
      <tr>
        <td>
          Emergency contact address:
        </td>
        <td>
          <textarea formControlName="emergencyContactAddress" cols="30" rows="5" id="emergency-contact"></textarea>
        </td>
      </tr>

    </table>
  </div>
  <div [formGroup]="schoolForm">
    <table>
      <tr>
        <td class="first-column">
          Learn Dutch at school:
        </td>
        <td class="second-column">
          Yes
          <input type="radio" [value]="true" formControlName="studyDutchInSchool">
          No
          <input type="radio" [value]="false" formControlName="studyDutchInSchool">
        </td>
      </tr>
      <tr>
        <td>
          Dutch studying years:
        </td>
        <td>
          <input formControlName="dutchStudyYears">
        </td>
      </tr>
      <tr>
        <td>
          Dutch studying hours/week:
        </td>
        <td>
          <input type="text" formControlName="dutchStudyHours">
        </td>
      </tr>
      <tr>
        <td>
          Dutch teacher's name:
        </td>
        <td>
          <input type="text" formControlName="dutchTeacherName">
        </td>
      </tr>
      <tr>
        <td>
          Learn English at school:
        </td>
        <td>
          Yes
          <input type="radio" [value]="true" formControlName="studyEnglishInSchool">
          No
          <input type="radio" [value]="false" formControlName="studyEnglishInSchool">
        </td>
      </tr>
      <tr>
        <td>
          English studying years:
        </td>
        <td>
          <input formControlName="englishStudyYears">
        </td>
      </tr>
      <tr>
        <td>
          English studying hours/week:
        </td>
        <td>
          <input type="text" formControlName="englishStudyHours">
        </td>
      </tr>
      <tr>
        <td>
          English teacher's name:
        </td>
        <td>
          <input type="text" formControlName="englishTeacherName">
        </td>
      </tr>
      <tr>
        <td>
          Learn French at school:
        </td>
        <td>
          Yes
          <input type="radio" [value]="true" formControlName="studyFrenchInSchool">
          No
          <input type="radio" [value]="false" formControlName="studyFrenchInSchool">
        </td>
      </tr>
      <tr>
        <td>
          French studying years:
        </td>
        <td>
          <input formControlName="frenchStudyYears">
        </td>
      </tr>
      <tr>
        <td>
          French studying hours/week:
        </td>
        <td>
          <input type="text" formControlName="frenchStudyHours">
        </td>
      </tr>
      <tr>
        <td>
          French teacher's name:
        </td>
        <td>
          <input type="text" formControlName="frenchTeacherName">
        </td>
      </tr>
      <tr>
        <td>
          How often this student speaks with family?:
        </td>
        <td>
          <select formControlName="frequencySpeakingWithFamily" [compareWith]="compareFrequency">
            <option *ngFor="let frequency of frequencies" [ngValue]="frequency">{{frequency.name}}</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>
          How often this student speaks with friends?:
        </td>
        <td>
          <select formControlName="frequencySpeakingWithFriends" [compareWith]="compareFrequency">
            <option *ngFor="let frequency of frequencies" [ngValue]="frequency">{{frequency.name}}</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>
          Has learning difficulty:
        </td>
        <td>
          Yes
          <input type="radio" [value]="true" formControlName="hasLearningDifficulty">
          No
          <input type="radio" [value]="false" formControlName="hasLearningDifficulty">
        </td>
      </tr>
      <tr>
        <td>
          Had language test:
        </td>
        <td>
          Yes
          <input type="radio" [value]="true" formControlName="hadLanguageTest">
          No
          <input type="radio" [value]="false" formControlName="hadLanguageTest">
        </td>
      </tr>
      <tr>
        <td>
          Language test date:
        </td>
        <td>
          <p-calendar formControlName="languageTestDate" [monthNavigator]="true" [yearNavigator]="true"
            yearRange="1990:2020" dateFormat="dd/mm/yy" [showOtherMonths]="false" [showIcon]="true"></p-calendar>
        </td>
      </tr>
      <tr>
        <td>
          Matter to review:
        </td>
        <td>
          <input type="text" formControlName="matterToReview">
        </td>
      </tr>
      <tr>
        <td>
          Study book name:
        </td>
        <td>
          <input type="text" formControlName="studyBookName">
        </td>
      </tr>
      <tr>
        <td>
          Coming with friends:
        </td>
        <td>
          Yes
          <input type="radio" [value]="true" formControlName="isComingWithFriends">
          No
          <input type="radio" [value]="false" formControlName="isComingWithFriends">
        </td>
      </tr>
      <tr>
        <td>
          Friend's name:
        </td>
        <td>
          <input formControlName="friendName">
        </td>
      </tr>
    </table>

    <button (click)="sendVademecum()" id="send-button">Update
      vademecum</button>
  </div>


</div>